import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Central scroll behavior: top on route change, anchored scroll when a
// hash is present (language switches keep their section anchor).
export default function ScrollManager() {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (window.__lenis) {
          window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
        } else {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 80);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash, key]);
  return null;
}
